export default __webpack_public_path__ + "static/media/TimeMachine.dce88584.svg";